import type { State } from '../../interfaces/State';
import type { ChapterContentAuthorization } from '../reducers/contentAuthorization';

export const selectContentAuthorization = (
  state: State,
  chapterId: number,
): ChapterContentAuthorization | null =>
  state.get('contentAuthorization')[chapterId] || null;
